import { jackpotService } from "@shared/utils/jp-socket";
import { checkResponse, post } from "@shared/utils/server";
import { channel } from "redux-saga";
import { all, call, fork, put, take, takeLatest } from "redux-saga/effects";

import { connectToWebSocket } from "../actions/jackpots";
import {
  DEFAULT_BANK_GROUP as defaultBankGroup,
  JP_ACCEPT_WIN,
  JP_CATCH_ERROR,
  JP_CONNECT,
  JP_GET_CURRENCY,
  JP_GET_STREAM_ID,
  JP_GET_STREAM_ID_FAILURE,
  JP_GET_STREAM_ID_SUCCESS,
  JP_SET_SLOTS,
  JP_SET_WINS,
  JP_UPDATE_COOLDOWNS,
  JP_UPDATE_SLOTS,
  JP_UPDATE_WINS,
} from "../constants";

const socketChannel = channel();

export function* getStreamId({ payload: { isCreateConnection } }) {
  try {
    const response = yield call(post, {
      method: "Lobby.getWsStream",
      args: { defaultBankGroup },
    });

    checkResponse(response);

    const streamId = response[0]?.stream ?? null;

    yield put({
      type: JP_GET_STREAM_ID_SUCCESS,
      payload: streamId,
    });

    if (isCreateConnection && streamId) {
      yield put(connectToWebSocket(streamId));
    }
  } catch (error) {
    yield put({
      type: JP_GET_STREAM_ID_FAILURE,
      payload: error,
    });
  }
}

export function* connect({ payload: { streamId } }) {
  try {
    yield call(() => jackpotService.connect(streamId));

    // Update slots & wins
    yield call(getSlotsAndWins);
    yield call(getCurrency);

    // Subscribe
    jackpotService.addSlotsListener((response) =>
      socketChannel.put({
        type: JP_UPDATE_SLOTS,
        payload: response,
      })
    );

    jackpotService.addWinsListener((response) =>
      socketChannel.put({
        type: JP_UPDATE_WINS,
        payload: response,
      })
    );

    jackpotService.addCooldownsListener((response) =>
      socketChannel.put({
        type: JP_UPDATE_COOLDOWNS,
        payload: response,
      })
    );
  } catch (error) {
    yield put({
      type: JP_CATCH_ERROR,
      payload: error,
    });
  }
}

export function* getSlotsAndWins() {
  try {
    const response = yield call(() => jackpotService.getSlotsAndWins());

    yield put({
      type: JP_SET_SLOTS,
      payload: response?.slots,
    });

    yield put({
      type: JP_SET_WINS,
      payload: response?.wins,
    });
  } catch (error) {
    yield put({
      type: JP_CATCH_ERROR,
      payload: error,
    });
  }
}

export function* getCurrency() {
  try {
    const response = yield call(() => jackpotService.getCurrency());

    yield put({
      type: JP_GET_CURRENCY,
      payload: response,
    });
  } catch (error) {
    yield put({
      type: JP_CATCH_ERROR,
      payload: error,
    });
  }
}

export function* acceptWin({ payload: { winId } }) {
  try {
    yield call(() => jackpotService.acceptWin(winId));
  } catch (error) {
    yield put({
      type: JP_CATCH_ERROR,
      payload: error,
    });
  }
}

export function* watchSocketChannel() {
  while (true) {
    const action = yield take(socketChannel);
    yield put(action);
  }
}

function* watchGetStreamId() {
  yield takeLatest(JP_GET_STREAM_ID, getStreamId);
}

function* watchConnectToWebSocket() {
  yield takeLatest(JP_CONNECT, connect);
}

function* watchAcceptWin() {
  yield takeLatest(JP_ACCEPT_WIN, acceptWin);
}

export default function* lobby() {
  yield all([
    fork(watchSocketChannel),
    fork(watchGetStreamId),
    fork(watchConnectToWebSocket),
    fork(watchAcceptWin),
  ]);
}
